;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.communityFeaturedSection = (function () {
    const initialize = function () {
      $('.community-featured-section__controls .js-controlLink').on('click', function (e) {
        e.preventDefault()
        const $this = $(this)
        const desiredLook = $(this).attr('data-filter-button')
        console.log('featured section change', $this, desiredLook)

        if (desiredLook === 'mirh') {
          // Show everything but closed.
          $('.community-featured-section__floorplans').addClass('hidden')
          $('.community-featured-section__mirh').removeClass('hidden')
        } else {
          $('.community-featured-section__floorplans').removeClass('hidden')
          $('.community-featured-section__mirh').addClass('hidden')
        }
        $this.parent().addClass('is-selected').siblings().removeClass('is-selected')
      })
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    eah.communityFeaturedSection.initialize()
  })
}(jQuery, window))
